var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"flex-row-reverse",attrs:{"no-gutters":""}},[(_vm.isLoading)?_c('b-spinner',{staticClass:"float-right mx-3",attrs:{"small":""}}):_c('span',{staticClass:"float-right font-weight-bold mx-3"},[_vm._v("Situação: "+_vm._s(_vm.situacao))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }